export const actionTypes = {
  SEARCH_REQUEST_START: 'CONTACTS.INSPECTION.SEARCH.REQUEST_START',
  SEARCH_REQUEST_SUCCESS: 'CONTACTS.INSPECTION.SEARCH.REQUEST_SUCCESS',
  SEARCH_REQUEST_FAILURE: 'CONTACTS.INSPECTION.SEARCH.REQUEST_FAILURE',
  SEARCH_RESET: 'CONTACTS.INSPECTION.SEARCH.RESET',
  ADD_REQUEST_START: 'CONTACTS.INSPECTION.ADD.REQUEST_START',
  ADD_REQUEST_SUCCESS: 'CONTACTS.INSPECTION.ADD.REQUEST_SUCCESS',
  ADD_REQUEST_FAILURE: 'CONTACTS.INSPECTION.ADD.REQUEST_FAILURE',
  DELETE_REQUEST_START: 'CONTACTS.INSPECTION.DELETE.REQUEST_START',
  DELETE_REQUEST_SUCCESS: 'CONTACTS.INSPECTION.DELETE.REQUEST_SUCCESS',
  DELETE_REQUEST_FAILURE: 'CONTACTS.INSPECTION.DELETE.REQUEST_FAILURE',
};

export function startSearchRequest(data) {
  return {
    type: actionTypes.SEARCH_REQUEST_START,
    payload: data,
  };
}

export function searchRequestSuccess(data) {
  return {
    type: actionTypes.SEARCH_REQUEST_SUCCESS,
    payload: data,
  };
}

export function searchRequestFailure(error) {
  return {
    type: actionTypes.SEARCH_REQUEST_FAILURE,
    payload: error,
  };
}

export function startAddRequest(data) {
  return {
    type: actionTypes.ADD_REQUEST_START,
    payload: data,
  };
}

export function addRequestSuccess(data) {
  return {
    type: actionTypes.ADD_REQUEST_SUCCESS,
    payload: data,
  };
}

export function addRequestFailure(error, data) {
  return {
    type: actionTypes.ADD_REQUEST_FAILURE,
    payload: {
      ...data,
      error,
    },
  };
}

export function startDeleteRequest(data) {
  return {
    type: actionTypes.DELETE_REQUEST_START,
    payload: data,
  };
}

export function deleteRequestSuccess(data) {
  return {
    type: actionTypes.DELETE_REQUEST_SUCCESS,
    payload: data,
  };
}

export function deleteRequestFailure(error, data) {
  return {
    type: actionTypes.DELETE_REQUEST_FAILURE,
    payload: {
      ...data,
      error,
    },
  };
}

export function resetSearch() {
  return {
    type: actionTypes.SEARCH_RESET,
  };
}
